import { hot } from "react-hot-loader/root";
import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { QueryClientProvider, QueryClient } from "react-query";
import TagManager from "react-gtm-module";
import config from "appConfig";
import { LessonContextProvider, LessonIntl } from "@jelly/lesson";
import Course from "../pages/Course";
import CourseWelcome from "../pages/CourseWelcome/CourseWelcome";
import Dashboard from "../pages/Dashboard";

import "../assets/styles/index.scss";

if (config.GTM_TAG) {
  const tagManagerArgs = {
    gtmId: config.GTM_TAG,
  };
  TagManager.initialize(tagManagerArgs);
}

const queryClient = new QueryClient();

const App: React.FC = () => {
  return (
    <LessonContextProvider>
      <QueryClientProvider client={queryClient}>
        <LessonIntl locale="en-gb">
          <Router basename={`${config.LMS_LANDING_PAGE_PATH || ""}`}>
            <Switch>
              <Route path="/course/:courseId/:lessonId" component={Course} />
              <Route path="/course/:courseId" component={CourseWelcome} />
              <Route path="/" component={Dashboard} title="ASKNow - Courses Dashbaord" />
            </Switch>
          </Router>
        </LessonIntl>
      </QueryClientProvider>
    </LessonContextProvider>
  );
};

export default hot(App);
